var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWidget3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.29163 5.95817C2.29163 3.93313 3.93325 2.2915 5.95829 2.2915C7.98334 2.2915 9.62496 3.93313 9.62496 5.95817C9.62496 7.98321 7.98334 9.62484 5.95829 9.62484C3.93325 9.62484 2.29163 7.98321 2.29163 5.95817Z",
    stroke: "#666666",
    strokeWidth: 1.375
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 16.0417C12.375 14.0166 14.0166 12.375 16.0417 12.375C18.0667 12.375 19.7083 14.0166 19.7083 16.0417C19.7083 18.0667 18.0667 19.7083 16.0417 19.7083C14.0166 19.7083 12.375 18.0667 12.375 16.0417Z",
    stroke: "#666666",
    strokeWidth: 1.375
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7083 5.95817C19.7083 3.93313 18.0667 2.2915 16.0417 2.2915C14.0166 2.2915 12.375 3.93313 12.375 5.95817C12.375 7.98321 14.0166 9.62484 16.0417 9.62484C18.0667 9.62484 19.7083 7.98321 19.7083 5.95817Z",
    stroke: "#666666",
    strokeWidth: 1.375
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62496 16.0417C9.62496 14.0166 7.98334 12.375 5.95829 12.375C3.93325 12.375 2.29163 14.0166 2.29163 16.0417C2.29163 18.0667 3.93325 19.7083 5.95829 19.7083C7.98334 19.7083 9.62496 18.0667 9.62496 16.0417Z",
    stroke: "#666666",
    strokeWidth: 1.375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidget3);
export default __webpack_public_path__ + "static/media/Widget 3.10c17c9a493e4b7ecafe2d627e71a6fb.svg";
export { ForwardRef as ReactComponent };